export default __webpack_public_path__ + "static/media/P545MAND1.c498b6fc.pdf";